import React from "react";

import loadingIcon from "../../../static/assets/loading_icon.svg"

const height = {height: 550};

const LoadingSpinner = () => (
    <div className="mp-0 container-fluid" style={height}>
        <img className="mp-0 absolute-center" src={loadingIcon} alt="loading icon"/>
    </div>
);

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/components/components/loading-spinner/loading-spinner.js